import PropTypes from 'prop-types';
import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import _ from 'lodash';

import t from '../../lib/I18n';
import Search from '../../records/Search';

import FeatureFlag from '../general/FeatureFlag';
import Radio from '../form/Radio';
import HelpIcon from '../general/HelpIcon';

function TocSpecificSelector ({ search, onChange }) {

    const label = (
        <div>
            { t('booking.operator.specifictoc', { toc: t('app.owner.short') }) }
            <HelpIcon icon={ 'info' }
                heading={ t('help.tocSpecific.title', { toc: t('app.owner.short') }) }
                message={ t('help.tocSpecific.message', { toc: t('app.owner.short') }) } />
        </div>
    );

    const tocOnly = search.tocSpecific;

    const _handleTocSpecificChange = (value) => () => {
        onChange(search.set('tocSpecific', !!value));
    };

    return (
        <FeatureFlag name="enableTocOnlySearch">
            <section className="booking__section">
                <Row>
                    <Col xs={ 12 }>
                        <FormGroup className="toc-specific-radio radio-group">
                            <div className="radio-option">
                                <Radio
                                    radioClass="regular-radio"
                                    className="radio-booking-operator-all"
                                    name="service-operator"
                                    label={ t('booking.operator.all') }
                                    checked={ !tocOnly }
                                    onChange={ _handleTocSpecificChange(false) }
                                    />
                            </div>
                            <div className="radio-option">
                                <Radio
                                    radioClass="regular-radio"
                                    className="radio-booking-operator-specific"
                                    name="service-operator"
                                    label={ label }
                                    checked={ tocOnly }
                                    onChange={ _handleTocSpecificChange(true) }
                                    />
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
            </section>
        </FeatureFlag>
    );
}

TocSpecificSelector.propTypes = {
    search: PropTypes.instanceOf(Search).isRequired,
    onChange: PropTypes.func
};

TocSpecificSelector.defaultProps = {
    onChange: _.noop
};

export default TocSpecificSelector;



// WEBPACK FOOTER //
// ./src/components/search/TocSpecificSelector.js